export default class ConsultationForm {
    static init(): void {
        const form = document.querySelector('.form_poptavka');
        const formSubmit = form?.querySelector('.kontakty__submit') as HTMLButtonElement;
        const selectboxes = form?.querySelectorAll('select[required="required"]') as NodeListOf<HTMLSelectElement>;

        if (!formSubmit || !form || !selectboxes) {
            return;
        }

        const inputs = form.querySelectorAll('input');

        selectboxes.forEach((selectbox) => {
            selectbox.addEventListener('change', () => {
                this.validateForm();
            });
        });

        inputs.forEach((input) => {
            input.addEventListener('change', () => {
                this.validateForm();
            });
        });

        formSubmit.addEventListener('click', (e) => {
            e.preventDefault();
            this.validateForm(formSubmit);
        });
    }

    static validateForm(submitButton?: HTMLButtonElement): void {
        const form = document.querySelector('.form_poptavka') as HTMLFormElement;
        const inputs = form?.querySelectorAll('input[required="required"]') as NodeListOf<HTMLInputElement>;
        const selectboxes = form?.querySelectorAll('select[required="required"]') as NodeListOf<HTMLSelectElement>;

        if (!inputs || !form) {
            return;
        }

        let elements = 0;
        let validElements = 0;
        selectboxes.forEach((selectbox) => {
            elements++;
            if (!selectbox.value) {
                if (selectbox.classList.contains('nice-select')) {
                    selectbox.classList.add('nice-select--error');
                }
            } else {
                selectbox.classList.remove('nice-select--error');
                validElements++;
            }
        });

        let invalidaInputs: HTMLInputElement[] = [];
        inputs.forEach((input) => {
            elements++;
            if (!input.value) {
                invalidaInputs.push(input);
                input.classList.add('form-control--error');
                return;
            } else {
                if (input.getAttribute('name') === 'email') {
                    if (!this.validateEmail(input.value)) {
                        invalidaInputs.push(input);
                        input.classList.add('form-control--error');
                        return;
                    } else {
                        validElements++;
                        input.classList.remove('form-control--error');
                    }
                } else if (input.getAttribute('name') === 'tel') {
                    // automaticky oddělovat číslo po 3 číslicích
                    if (input.value.length > 9) {
                        input.value = input.value.replace(/(\d{3})(\d{3})(\d{3})(\d{3})/, '$1 $2 $3 $4');
                    } else {
                        input.value = input.value.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3');
                    }

                    if (!this.validatePhone(input.value)) {
                        invalidaInputs.push(input);
                        input.classList.add('form-control--error');
                        return;
                    } else {
                        validElements++;
                        input.classList.remove('form-control--error');
                    }
                } else {
                    validElements++;
                    input.classList.remove('form-control--error');
                }
            }
        });

        if (invalidaInputs.length > 0) {
            if (submitButton) {
                invalidaInputs[0].focus();
            }
        } else if (validElements === elements) {
            if (submitButton) {
                form.submit();
            }
        }
    }

    static validateEmail(email: string): boolean {
        // min 2 znaky po poslední tečce
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    static validatePhone(phone: string): boolean {
        // min 9 znaků, povolit poze číslice, mezery a +, povolit i 00420
        const re = /^(\+420|00420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/;
        return re.test(phone);
    }
}
